function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3946 13.2742C18.3931 13.4416 18.3088 13.6019 18.1598 13.7203C18.0108 13.8387 17.8091 13.9059 17.5983 13.9072H3.13693C2.92567 13.907 2.72314 13.8403 2.57383 13.7216C2.42452 13.6029 2.34065 13.442 2.34065 13.2742V12.6323H16.7892V5.17433L10.3676 9.76387L2.34065 4.02694V3.07079C2.34065 2.90173 2.42522 2.73959 2.57576 2.62005C2.72629 2.50051 2.93046 2.43335 3.14335 2.43335H17.5919C17.8048 2.43335 18.009 2.50051 18.1595 2.62005C18.31 2.73959 18.3946 2.90173 18.3946 3.07079V13.2742ZM4.29442 3.70822L10.3676 8.04916L16.4408 3.70822H4.29442ZM0.73526 10.0826H7.15684V11.3575H0.73526V10.0826ZM0.73526 6.8954H4.74875V8.17027H0.73526V6.8954Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2647,
  height: 15.2985,
  fill: "white",
  transform: "translate(0.73526 0.520996)"
})));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.5757a4f5.svg";
export { ForwardRef as ReactComponent };